// Unified Auth Hook - Uses the new auth store instead of AuthContext
// This replaces the old useAuth hook to eliminate circular dependencies

import { useAuthStore } from '@/shared/stores/authStore';

/**
 * Custom hook for accessing unified authentication state and methods
 *
 * This hook provides access to the unified auth store that combines
 * authentication and demo functionality, eliminating circular dependencies.
 */
export const useAuthUnified = () => {
  const store = useAuthStore();
  return {
    ...store,
    // Ensure all new properties are available
    isFullyReady: store.isFullyReady ?? false,
    isDemoTransitioning: store.isDemoTransitioning ?? false,
  };
};

// Individual selectors to prevent infinite loops
export const useAuthDemo = () => {
  const isDemoMode = useAuthStore(state => state.isDemoMode);
  const demoEmployee = useAuthStore(state => state.demoEmployee);
  const availableEmployees = useAuthStore(state => state.availableEmployees);
  const isDevEnvironment = useAuthStore(state => state.isDevEnvironment);
  const switchToDemo = useAuthStore(state => state.switchToDemo);
  const exitDemo = useAuthStore(state => state.exitDemo);

  return {
    isDemoMode,
    demoEmployee,
    availableEmployees,
    isDevEnvironment,
    switchToDemo,
    exitDemo,
  };
};
